import { render, staticRenderFns } from "./Trophy.vue?vue&type=template&id=a637b80a&"
import script from "./Trophy.vue?vue&type=script&lang=js&"
export * from "./Trophy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports